import FourCubes from '../../../components/Icons/FourCubes';
import JobsIcon from '../../../components/Icons/JobsIcon';
import PlaneIcon from '../../../components/Icons/PlaneIcon';
import SettingsIcon from '../../../components/Icons/SettingsIcon';
import { APPLICATION, DASHBOARD, JOBS, UERS_SETTINGS } from '../../../routes/routeConstants';

interface INavConfig {
  title: string;
  path: string;
  icon: any;
}

export const navConfig: INavConfig[] = [
  {
    title: 'Dashboard',
    path: DASHBOARD,
    icon: <FourCubes />,
  },

  {
    title: 'Jobs',
    path: JOBS,
    icon: <JobsIcon />,
  },

  {
    title: 'Applications',
    path: APPLICATION,
    icon: <PlaneIcon />,
  },

  {
    title: 'Settings',
    path: UERS_SETTINGS,
    icon: <SettingsIcon />,
  },
];
